/* eslint-disable */
import React from 'react'
import Notification from 'rc-notification'
import 'rc-notification/assets/index.css'
import errorIcon from '../../static/images/error-icon.svg'
import successIcon from '../../static/images/success-icon.svg'
import { isMobile } from '../../utils/bomUtils'

const alert = msg => {
  const dom = document.createElement('div')
  dom.className = 'alert'
  dom.innerText = msg
  document.body.appendChild(dom)
  setTimeout(() => {
    document.body.removeChild(dom)
  }, 3000)
}

let notification = null
Notification.newInstance({}, n => {
  if (!notification) {
    notification = n
  }
})

const info = msg => {
  if (isMobile()) {
    alert(msg)
  } else {
    notification.notice({
      content: (
        <span className="notification">
          <img src={successIcon} />
          {msg}
        </span>
      ),
    })
  }
}

const warn = msg => {
  if (isMobile()) {
    alert(msg)
  } else {
    notification.notice({
      duration: '5',
      content: (
        <span className="notification">
          <img src={errorIcon} />
          {msg}
        </span>
      ),
    })
  }
}

export default { info, warn }
